import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";
import { Outlet } from "react-router-dom";

export default function Layout() {
    return (
        <div className="flex h-screen bg-[#020617] text-white">

            {/* Sidebar */}
            <Sidebar />

            {/* Main */}
            <div className="flex-1 flex flex-col">

                {/* Topbar */}
                <Topbar />

                {/* Page Content */}
                <div className="p-6 overflow-auto flex-1">
                    <Outlet />
                </div>

            </div>
        </div>
    );
}